import { AxiosResponse } from 'axios';
import { createClient } from 'services/clientConfiguration';
import * as FlowBuilderTypes from 'types/FlowBuilder';

const BASE_URL = '/rest-api/flow-builder-orchestrator-service/v2/flows';

const http = createClient({
  baseURL: BASE_URL,
});

export const getFlows = (
  corpAcctNbr: number,
  ssoToken: string,
): Promise<AxiosResponse<FlowBuilderTypes.Flow[]>> => {
  const url = `/?contexts=VOICE`;
  return http.get(url, {
    headers: {
      'nextiva-context-corpAcctNumber': `${corpAcctNbr}`,
      Authorization: `Bearer ${ssoToken}`,
    },
  });
};
